<template>
  <Modal title="快速填写（选择本人已报名过的信息）" v-model="isShowModal" @on-ok="closeModal">
    <ModalLayout>
      <DragTable
        noSearch
        class="iv-m-t-24"
        :showEdit="false"
        :showDelete="false"
        :url="listUrl"
        :listData="listData"
        ref="DragTable"
        :showSelect="false"
        :showRadioSelect="true"
        :immediateForce="true"
        :columns="columns"
        @on-radio-change="selectForm">
      </DragTable>
    </ModalLayout>
  </Modal>
</template>

<script>
import columns from './columns.js'
import Modal from '@/components/modal'
import ModalLayout from '@/components/modal/layout'
import DragTable from '@/components/drag-table-inline'

export default {
  data () {
    return {
      isShowModal: false,
      listUrl: 'api-general/module/selection/personalCenter/signUp/appraising/listSignUpRecord',
      listData: {},
      signUpId: ''
    }
  },
  created () {
    this.columns = columns.call(this)
  },
  inject: ['quickShowModal'],
  methods: {
    selectForm (row) {
      this.signUpId = row.signUpId
    },
    closeModal () {
      this.isShowModal = false
      this.signUpId && this.quickShowModal(this.signUpId)
    },
    open (prize, bizLineCode) {
      this.listData = {
        bizTypeCode: prize.bizTypeCode,
        basicFormType: prize.basicFormType,
        bizLineCode: bizLineCode
      }
      this.isShowModal = true
    }
  },
  components: {
    Modal,
    DragTable,
    ModalLayout
  }
}
</script>
